import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type WarehouseRoutingFieldsFragment = { __typename?: 'WarehouseRouting', default_warehouse_uuid?: string | null, fallback_warehouse_uuid: string, countries: Array<{ __typename?: 'WarehouseRoutingCountryEntry', country_code: string, warehouse_uuid: string }> };

export type OrderWarehouseConfigFieldsFragment = { __typename?: 'OrderWarehouseConfig', non_event: { __typename?: 'WarehouseRouting', default_warehouse_uuid?: string | null, fallback_warehouse_uuid: string, countries: Array<{ __typename?: 'WarehouseRoutingCountryEntry', country_code: string, warehouse_uuid: string }> }, event: { __typename?: 'WarehouseRouting', default_warehouse_uuid?: string | null, fallback_warehouse_uuid: string, countries: Array<{ __typename?: 'WarehouseRoutingCountryEntry', country_code: string, warehouse_uuid: string }> } };

export const WarehouseRoutingFieldsFragmentDoc = gql`
    fragment WarehouseRoutingFields on WarehouseRouting {
  default_warehouse_uuid
  countries {
    country_code
    warehouse_uuid
  }
  fallback_warehouse_uuid
}
    `;
export const OrderWarehouseConfigFieldsFragmentDoc = gql`
    fragment OrderWarehouseConfigFields on OrderWarehouseConfig {
  non_event {
    ...WarehouseRoutingFields
  }
  event {
    ...WarehouseRoutingFields
  }
}
    ${WarehouseRoutingFieldsFragmentDoc}`;